import { Input, Label } from '@/components/Forms/styles';
import { twMerge } from 'tailwind-merge';

type Props = {
  name: string;
  maxLength?: number;
  type?: string;
  label: string;
  className?: string;
  required?: boolean;
  pattern?: string;
};

const Web2CaseInput = ({
  name,
  type = 'text',
  maxLength,
  label,
  className,
  required,
  pattern,
}: Props) => {
  return (
    <div className={twMerge('w-full', className)}>
      <Label htmlFor={name}>{label}</Label>
      <Input
        id={name}
        name={name}
        type={type}
        maxLength={maxLength}
        required={required}
        pattern={pattern}
      />
    </div>
  );
};

export default Web2CaseInput;
